/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type HpRespShopByModule_componentModule = {
    readonly title: string | null;
    readonly items: ReadonlyArray<{
        readonly cmsId: number | null;
        readonly linkData: {
            readonly path: string | null;
        };
        readonly " $fragmentRefs": FragmentRefs<"HpRespShopByModuleItem_item">;
    } | null> | null;
    readonly " $refType": "HpRespShopByModule_componentModule";
};
export type HpRespShopByModule_componentModule$data = HpRespShopByModule_componentModule;
export type HpRespShopByModule_componentModule$key = {
    readonly " $data"?: HpRespShopByModule_componentModule$data;
    readonly " $fragmentRefs": FragmentRefs<"HpRespShopByModule_componentModule">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpRespShopByModule_componentModule",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Product",
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "cmsId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "LinkData",
          "kind": "LinkedField",
          "name": "linkData",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "path",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "HpRespShopByModuleItem_item"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ShopByModule",
  "abstractKey": null
};
(node as any).hash = 'c5332c47810ed1c59a2c85a5684a5cc7';
export default node;
